import React from "react";
import QRCODE from "../../assets/final/qrcode.png";
import Seal from "../../assets/final/seal.png";
import BasicLayout from "../../layouts/BasicLayout";
import "./index.scss";

const Result = ({ points, restartGame }) => {
  const renderMessage = () => {
    if (points >= 90) {
      return "原来你就是藏在人间的鹊桥仙！ 转发让更多朋友知道玉兔邀您回仙界一游~";
    }
    if (points > 60 && points < 90) {
      return "丘比特算什么！你的网线就是牛郎和织女的红线。转发让更多朋友交上好运~";
    } else {
      return "朗朗夜空，是你的十盏明灯点亮了牵牛织女星！转发让更多朋友沐浴在这光辉下~";
    }
  };

  return (
    <BasicLayout>
      <div className="final" id="qr-code">
        <div className="result-container" id="final-result">
          <div className="result-message">
            <div className="points">{points}分</div>
            <div className="message">{renderMessage()}</div>
          </div>
          <div className="qr">
            <img className="qr-image" src={QRCODE} width="100px" height="100px" />
          </div>
        </div>

        <div className="restart-button">
          <button className="primary-button" onClick={() => restartGame()}>
            重新开始
          </button>
        </div>

        <div className="image-button">
          <p style={{ textAlign: "center" }}>
            分享链接或截图
            <br />
            转发分享给你的小伙伴吧!
          </p>
        </div>

        <div className="seal">
          <img src={Seal} width="20px" />
        </div>
      </div>
    </BasicLayout>
  );
};

export default Result;
